export const STYLES = {
	modal: {
		colors: {
			purple: '#565ADD',
			white: '#EFF0FF',
		},
	},
	background: {
		colors: {
			lightBackground: '#FFF',
			darkBackground: '#1D2125',
			lightOutline: '#B2B3F1',
			darkOutline: '#3D2E7C',
		},
	},
	controls: {
		colors: {
			lightBackground: '#FFF',
			darkBackground: '#1D2125',
		},
	},
} as const;

export const TEST_IDS = {
	loomRecordVideoButton:
		'issue-view-foundation.quick-add.loom-record-item-ad.loom-record-video-quick-add-item',
	loomRecordVideoIcon:
		'issue-view-foundation.quick-add.loom-record-item-ad.loom-record-video-quick-add-item-icon',
	tryNowButton: 'issue-view-foundation.quick-add.loom-record-item-ad.try-now',
	dismissButton: 'issue-view-foundation.quick-add.loom-record-item-ad.dismiss',
	adControlOptionsButton: 'issue-view-foundation.quick-add.loom-record-item-ad.ad-options',
	getStartedLink: 'issue-view-foundation.quick-add.loom-record-item-ad.get-started',
	cancelSignupButton: 'issue-view-foundation.quick-add.loom-record-item-ad.cancel-signup',
	adControlsPrivacyPolicy:
		'issue-view-foundation.quick-add.loom-record-item-ad.ad-controls-privacy-policy',
	linkIssue: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.link-issue',
	adControlFlag: 'act-flag-loom-ad-issue-view-ad-controls-dismiss',
	loomRecordVideoButtonV1:
		'issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.quick-add-item-view',
};

export const SIGN_UP_URL =
	'https://loom.com/signup?welcome_from=Jira&utm_campaign=atlassian_loom_demand&utm_source=issue-view-quick-add-v0&utm_content=jira';

export const PRIVACY_POLICY_URL = 'https://www.atlassian.com/legal/privacy-policy';

export const STORAGE_KEY = 'jira-issue-action-view-loom-ad';
export const AD_SUPPRESSED = 'ad-supressed';

export const SUBJECT_IDS = {
	adControlsFlagDismissed: 'loom-record-quick-add-ad-control-flag-dismissed',
	adControlsMenuButton: 'loom-record-quick-add-ad-control-menu-button',
	adControlsResonsMenuButton: 'loom-record-quick-add-ad-control-reasons-menu-button',
	adControlsNotInterestedButton: 'loom-record-quick-add-ad-control-not-interested-button',
	loomRecordVideoButton: 'loom-record-quick-add-button',
	loomCloseIconCard: 'loom-record-quick-add-close-icon-card',
	loomRecordVideoButtonTryNow: 'loom-record-quick-add-button-try-now',
	modalCancelButton: 'loom-record-quick-add-modal-cancel-button',
	modalCtaButton: 'loom-record-quick-add-modal-cta-button',
};
